import { useNavigate, useSearchParams } from "react-router-dom";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import IconsColor from '../../utility/iconsColor';

import globalStyles from '../../../assets/styles/global.module.scss';
import styles from '../../../assets/styles/componentStyles/templateLibraryStyles/templateLibrary.module.scss';

import GlobalButton from "../../utility/globalButton/button";
import { createWhatsappTemplatePayloadForTemplateLibrary } from "../../../models/axiosModel";
import { useTemplateLibraryStore } from "../../../store/templateLibraryStore";
import { createBasicTemplateFromScratch } from './constant';
import { whiteColor } from "../../../utils/colors";
import { useCarouselFunctions } from "./utils/useCarouselFunctions";

const TemplateLibraryHeader = () => {

  const { isScreenBelow1000 } = useCarouselFunctions();

  const setSelectedTemplateId = useTemplateLibraryStore((state) => state.setSelectedTemplateId);
  const setSelectedTemplate = useTemplateLibraryStore((state) => state.setSelectedTemplate);
  const whatsappTemplateButtonGenericData = useTemplateLibraryStore((state) => state.whatsappTemplateButtonGenericData);
  const getWhatsappTemplateButtonTypeApiCall = useTemplateLibraryStore((state) => state.getWhatsappTemplateButtonTypeApiCall);
  const templateLibraryCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');

  const handleCreateFromScratch = async () => {
    if (!whatsappTemplateButtonGenericData || whatsappTemplateButtonGenericData.length === 0) {
      await getWhatsappTemplateButtonTypeApiCall();
    }

    setSelectedTemplate(createBasicTemplateFromScratch(templateLibraryCategoryList ?? [], whatsappTemplateButtonGenericData ?? []) as createWhatsappTemplatePayloadForTemplateLibrary);
    setSelectedTemplateId('');
    navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${id}`);
  };

  return (
    <>
      <Grid container className={`${styles.templateLibrary__header} ${globalStyles.fullwidth}`}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" className={`${styles.templateLibrary__header} ${globalStyles.fullwidth}`}>
          
          <Typography className={styles.templateLibrary__title}>
            Template Library
          </Typography>

          {/* Create from Scratch Button */}
          {isScreenBelow1000 ? (
            <button
                type="button"
                className={`${globalStyles.clickable} ${styles.templateLibrary__headerCreateBtn}`}
                onClick={() => { handleCreateFromScratch() }}
            >
              Create
            </button>
          ) : (
            <GlobalButton
              buttonText="Create from Scratch"
              className="primaryButtonStyle"
              startIcon={<IconsColor iconName="plus" fillColor={whiteColor} width="15px" height="15px" />}
              sx={{ minWidth: '210px'}}
              onClick={() => { handleCreateFromScratch() }}
            />
          )}
          
        </Stack>

        <Divider orientation="horizontal" style={{ opacity: "1", width: "100%" }} />
      </Grid>
    </>
  );
};

export default TemplateLibraryHeader;
